// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Plyr from 'plyr';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      if ( $( '#player' ).length ) {
        // Plyr
        const player = new Plyr( '#player', {
          hideControls: true,
          settings: [],
          controls: [],
        } );

        const stopAt = parseInt( $( '#player' ).attr( 'data-stop' ) ) * 1000;
        const vidLength = parseInt( $( '#player' ).attr( 'data-length' ) ) * 1000;
        const remainingTime = vidLength - stopAt;
        let playing = false;
        let timer;

        $( document ).on( 'ready', function() {
          if ( playing ) {
            player.restart();
            player.pause();
            clearInterval( timer );
          }
          player.play();
          playing = true;
          let newStopAt = stopAt - ( player.currentTime * 1000 );
          // console.log( stopAt );

          if ( newStopAt < 0 ) {
            newStopAt = stopAt;
          }

          timer = setTimeout( function() {
            player.pause();
            playing = false;
          }, newStopAt );
        } );

        $( '.previous-page' ).click( function( e ) {
          e.preventDefault();

          if ( $( '.plyr' ).is( ':visible' ) ) {
            const href = $( this ).attr( 'href' );
            e.preventDefault();
            if ( playing ) {
              player.currentTime = remainingTime / 1000;
              player.pause();
              clearInterval( timer );
            }
            player.play();
            playing = true;

            timer = setTimeout( function() {
              player.pause();
              playing = false;
              window.location = href;
            }, remainingTime );
          }
        } );
      }
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'team', COMPONENT );
} )( app );
